export function mergeUniquely(arr1 = [], arr2 = [], key) {
    const newArr = arr1.concat(arr2);
    const map = {};
    const res = [];
    newArr.forEach(el => {
      if( !map[el[key]]) {
         if(!el.deleted) res.push(el);
          map[el[key]] = true;
       }
    })
    return res;
 }